import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { normalizeTicketId, readTicketParam, sanitizePortalTarget } from "./managementDeepLink";

// Keep return destinations in this history entry, not in the visible login URL.
// Unlike shared storage, history state survives reload without leaking an old
// destination into a later, unrelated sign-in or another browser tab.
export const useManagementLoginLink = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const deepLink = useMemo(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      return {
        next: sanitizePortalTarget(params.get("next")),
        ticket: readTicketParam(location.search),
      };
    }
    const saved = location.state?.managementDeepLink;
    return {
      next: sanitizePortalTarget(saved?.next),
      ticket: normalizeTicketId(saved?.ticket),
    };
  }, [location.search, location.state]);

  useEffect(() => {
    if (!location.search) return;
    navigate({ pathname: location.pathname, hash: location.hash }, {
      replace: true,
      state: { managementDeepLink: deepLink },
    });
  }, [location.search, location.pathname, location.hash, deepLink, navigate]);

  return deepLink;
};